<div class="flex-container">

  <ng-container *ngTemplateOutlet="inRcJit ? rcJitTemplate : defaultTemplate"></ng-container>
  <mat-card>

    <mat-tab-group dynamicHeight="true" animationDuration="250ms" class="tab-group">

      <mat-tab label="Variables">
        <div class="side-by-side">
          @if (before) {
            <app-variable-display [title]="beforeLabel"
            [variables]="before.variables"></app-variable-display>
          }
          @if (after) {
            <app-variable-display [title]="afterLabel" [variables]="after.variables"></app-variable-display>
          }
        </div>
      </mat-tab>

      <mat-tab label="Tasks">
        <div class="side-by-side">
          @if (before) {
            <app-task-display [title]="beforeLabel"
            [environments]="before.environments" [serviceConnections]="serviceConnections"></app-task-display>
          }
          @if (after) {
            <app-task-display [title]="afterLabel" [environments]="after.environments" [serviceConnections]="serviceConnections"></app-task-display>
          }
        </div>
      </mat-tab>

    </mat-tab-group>
  </mat-card>
  <br/>
  <div class="footer">
    <span>This page is based on <a
      href="https://github.com/aproulx232/mario-reviewer"
      class="mario-link"
      target="_blank"
    rel="noopener">mario-reviewer</a></span>
  </div>
</div>

<ng-template #rcJitTemplate>
  <div class="side-by-side">
    <div>
      <app-mario-header [title]="beforeLabel" [document]="before" [inRcJit]="true"></app-mario-header>
    </div>

    <div>
      <app-mario-header [title]="afterLabel" [document]="after" [inRcJit]="true"></app-mario-header>
    </div>
  </div>
</ng-template>

<ng-template #defaultTemplate>
  <div class="side-by-side">
    <div class="side-content">
      <app-mario-header [title]="beforeLabel" [document]="before"></app-mario-header>
      <div class="form-container">
        <mat-form-field class="release-form">
          <mat-label>Release Definition</mat-label>
          <input #beforeReleaseInput type="text" matInput [(ngModel)]="beforeReleaseDefinition"
            (input)="updateBeforeFilteredReleaseDefinitions(beforeReleaseInput.value)" [matAutocomplete]="autoBefore"
            required
            [attr.aria-label]="'Before Release Definition'"
            placeholder="Select a release definition"
            title="Before Release Definition"
            />
          <mat-autocomplete #autoBefore="matAutocomplete" [displayWith]="displayRcName">
            @for (releaseDefinition of filteredReleaseDefinitionsBefore  | async; track releaseDefinition) {
              <mat-option
                [value]="releaseDefinition">
                {{ releaseDefinition.name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="openDialog(beforeReleaseDefinition!, beforeLabel)"
        [disabled]="!beforeReleaseDefinition">Select Revision</button>
      </div>
    </div>

    <div class="reset-container">
      <button mat-raised-button color="primary" (click)="reset()">Reset</button>
    </div>

    <div class="side-content">
      <app-mario-header [title]="afterLabel" [document]="after"></app-mario-header>
      <div class="form-container">
        <mat-form-field class="release-form">
          <mat-label>Release Definition</mat-label>
          <input #afterReleaseInput type="text" matInput [(ngModel)]="afterReleaseDefinition"
            (input)="updateAfterFilteredReleaseDefinitions(afterReleaseInput.value)" [matAutocomplete]="autoAfter"
            required
            [attr.aria-label]="'After Release Definition'"
            placeholder="Select a release definition"
            title="After Release Definition"
            />
          <mat-autocomplete #autoAfter="matAutocomplete" [displayWith]="displayRcName">
            @for (releaseDefinition of filteredReleaseDefinitionsAfter | async; track releaseDefinition) {
              <mat-option
                [value]="releaseDefinition">
                {{ releaseDefinition.name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="openDialog(afterReleaseDefinition!, afterLabel)"
        [disabled]="!afterReleaseDefinition">Select Revision</button>
      </div>
    </div>
  </div>
</ng-template>
